import { createFileRoute, notFound, redirect } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import {
  areReceiptsSearchEqual,
  normalizeReceiptsSearch,
  ReceiptDetailPage,
  merchantReceiptDetailQueryOptions,
  normalizeReceiptDetailParams,
  receiptsSearchSchema,
} from '@/features/receipts';

export const Route = createFileRoute('/_authed/receipts/$transactionId')({
  validateSearch: zodValidator(receiptsSearchSchema),
  loader: ({ context, params }) => {
    const normalizedParams = normalizeReceiptDetailParams(params);

    if (!normalizedParams) {
      throw notFound();
    }

    void context.queryClient.prefetchQuery(
      merchantReceiptDetailQueryOptions(normalizedParams.transactionId),
    );

    return normalizedParams;
  },
  beforeLoad: ({ params, search }) => {
    const normalizedSearch = normalizeReceiptsSearch(search);

    if (!areReceiptsSearchEqual(search, normalizedSearch)) {
      const normalizedParams = normalizeReceiptDetailParams(params);
      if (!normalizedParams) {
        throw notFound();
      }

      throw redirect({
        to: '/receipts/$transactionId',
        params: { transactionId: normalizedParams.transactionId },
        search: normalizedSearch,
        replace: true,
      });
    }
  },
  component: ReceiptDetailRouteComponent,
});

function ReceiptDetailRouteComponent() {
  const { transactionId } = Route.useLoaderData();
  const search = Route.useSearch();

  return <ReceiptDetailPage transactionId={transactionId} backSearch={search} />;
}
